import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { Store } from '@ngrx/store';
import { AuthSelectors } from '@/app/+state/auth';

@Component({
    selector: 'qc-unauthorized',
    standalone: true,
    imports: [CommonModule, ButtonModule, CardModule],
    template: `
        <div class="flex items-center justify-center min-h-screen bg-gray-50">
            <div class="max-w-md w-full mx-4">
                <p-card>
                    <div class="text-center">
                        <div class="mb-6">
                            <i class="pi pi-ban text-6xl text-red-500"></i>
                        </div>
                        
                        <h1 class="text-2xl font-bold text-gray-900 mb-4">
                            Access Denied
                        </h1>
                        
                        <p class="text-gray-600 mb-6">
                            You don't have permission to access this page. 
                            Your current role ({{ (currentUser$ | async)?.role }}) doesn't allow this action.
                        </p>
                        
                        <div class="space-y-3">
                            <p-button 
                                label="Go Back" 
                                (click)="goBack()" 
                                class="w-full"
                                severity="secondary"
                            />
                            
                            <p-button 
                                label="Go to Dashboard" 
                                (click)="goToDashboard()" 
                                class="w-full"
                            />
                        </div>
                        
                        <div class="mt-6 pt-6 border-t border-gray-200">
                            <p class="text-sm text-gray-500">
                                If you believe this is an error, please contact your system administrator.
                            </p>
                        </div>
                    </div>
                </p-card>
            </div>
        </div>
    `,
})
export class UnauthorizedComponent {
    private readonly router = inject(Router);
    private readonly store = inject(Store);
    
    currentUser$ = this.store.select(AuthSelectors.selectUser);

    goBack(): void {
        window.history.back();
    }

    goToDashboard(): void {
        this.router.navigate(['/']);
    }
}
